'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { initTelemetry, setUserContext, clearUserContext } from '@/lib/telemetry'

/**
 * Initializes Application Insights and syncs user context from NextAuth.
 *
 * Place inside SessionProvider so useSession() has access to the auth state.
 * No-ops when NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING is unset (local dev).
 */
export function TelemetryProvider({ children }: { children: React.ReactNode }) {
  const { data: session, status } = useSession()

  // Initialize App Insights once on mount
  useEffect(() => {
    initTelemetry()
  }, [])

  // Sync authenticated user context when session changes
  useEffect(() => {
    if (status === 'authenticated' && session?.user) {
      const userId = session.user.id ?? session.user.email ?? 'unknown'
      setUserContext(userId, session.user.email ?? undefined)
    } else if (status === 'unauthenticated') {
      clearUserContext()
    }
  }, [session, status])

  return <>{children}</>
}
